import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import {
  ApiQueryPayerEngagementWorkDefinitions,
  getPayerEngagementsWorkDefinitions
} from "../../../services/payerEngagements/getPayerEngagementWorkDefinitions";

export const QUERY_ENGAGEMENT_WORK_DEFINITIONS =
  "QUERY_ENGAGEMENT_WORK_DEFINITIONS";

export const useQueryEngagementsWorkDefinitions = (
  params: {
    payerId: string;
    engagementId: string;
  } & ApiQueryPayerEngagementWorkDefinitions,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getPayerEngagementsWorkDefinitions>>,
    WSServiceError
  >
) => {
  const { payerId, engagementId, ...query } = params;
  return useWSQuery(
    [QUERY_ENGAGEMENT_WORK_DEFINITIONS, params],
    () => getPayerEngagementsWorkDefinitions({ payerId, engagementId }, query),
    config
  );
};
